<template>
  <div class="report_index">
    <div class="report_title">
      <el-icon class="el-icon-edit-outline"></el-icon> 理赔报案
    </div>
    <div class="report_form">
      <div class="report_form_one">
        <div class="report_form_title">
          提交时间
        </div>
        <div class="report_form_input">
          {{ new Date(form.utime*1000).toLocaleString() }}
        </div>
      </div>
      <div class="report_form_one">
        <div class="report_form_title">
          船舶名称 <span style="color:red;font-size:.7rem;">*</span>
        </div>
        <div class="report_form_input">
          {{ form.shipname }}
        </div>
      </div>
      <div class="report_form_one">
        <div class="report_form_title">
          保单号 <span style="color:red;font-size:.7rem;">*</span>
        </div>
        <div class="report_form_input">
          {{ form.policy_number }}
        </div>
      </div>
      <div class="report_form_one">
        <div class="report_form_title">
          出险地点 <span style="color:red;font-size:.7rem;">*</span>
        </div>
        <div class="report_form_input">
          {{ form.report_address }}
        </div>
      </div>
      <div class="report_form_one">
        <div class="report_form_title">
          出险日期 <span style="color:red;font-size:.7rem;">*</span>
        </div>
        <div class="report_form_input">
          {{ new Date(form.report_datetime*1000).toLocaleString() }}
        </div>
      </div>
      <div class="report_form_one" v-if="form.img_list.length>0">
        <div class="report_form_title">
          上传的图片
        </div>
      </div>
      <div class="report_media_box" v-if="form.img_list.length>0">
        <div class="report_media_one" v-for="(img,index) in form.img_list" :key="index">
          <el-image :src="img" :preview-src-list="form.img_list"/>
        </div>
      </div>
      <div class="report_form_one" v-if="form.video_list.length>0">
        <div class="report_form_title">
          上传的视频
        </div>
      </div>
      <div class="report_media_box" v-if="form.video_list.length>0">
        <div class="report_media_one" v-for="(video,index) in form.video_list" :key="index">
          <el-image :src="video"/>
        </div>
      </div>
      <div class="report_form_one">
        <div class="report_form_title">
          手机号 <span style="color:red;font-size:.7rem;">*</span>
        </div>
        <div class="report_form_input">
          <a style="text-decoration: none;" rel="nofollow" :href="`tel:`+form.phone">{{ form.phone }}</a>
        </div>
      </div>
      <div class="report_form_one">
        <div class="report_form_title">
          出险经过 <span style="color:red;font-size:.7rem;">*</span>
        </div>
        <div class="report_form_input">
          {{ form.report_detail }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { reportGet } from '../../api/api'

  export default {
    name: "ReportReview",
    data() {
      return {
        rid: this.$route.query.rid,
        form:{
          shipname:'加载中',
          policy_number:'加载中',
          report_address:'加载中',
          report_datetime:0,
          phone:'加载中',
          report_detail:'加载中',
          img_list:[],
          video_list:[],
          utime:0
        }
      }
    },
    mounted() {
      reportGet(this.rid).then(res => {
        if(res && res.status === 0){
          res.data['img_list'] = JSON.parse(res.data['img_list']);
          res.data['video_list'] = JSON.parse(res.data['video_list']);
          this.form = res.data;
        }else{
          this.$message.error(res.message);
          this.$router.push('/report/index');
        }
      })
    },
    methods: {

    }
  }
</script>

<style scoped>
  .report_index {
    top: 6vh;
    left: 0;
    position: absolute;
    height: 94vh;
    width: 100%;
    margin: 0;
    background-color: #eee;
    overflow-y: scroll;
  }
  .report_title {
    height:2rem;
    line-height:2rem;
    text-indent: .5rem;
    font-size:.95rem;
    color:#03a7d5;
  }
  .report_bottom {
    width:100%;
    position:absolute;
    bottom:0;
    height:3.2rem;
    line-height:3.2rem;
    border-top:1px #ddd dashed;
  }
  .report_form {
    height:80vh;
    overflow-y: scroll;
  }
  .report_form_one {
    height:2.7rem;
    line-height:2.7rem;
    width:90%;
    margin:.5rem 5%;
  }
  .report_form_title {
    width:20%;
    float:left;
    font-size:.8rem;
    color:#666;
    height:2.7rem;
    line-height:3rem;
  }
  .report_form_input {
    margin-left:3%;
    width:75%;
    float:left;
    height:2.7rem;
    line-height:2.7rem;
    font-size:.95rem;
  }
  .report_media_box {
    width:100%;
    height:4rem;
    overflow:hidden;
  }
  .report_media_one {
    height:3rem;
    width:20%;
    margin:.5rem 5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/review.vue